import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

interface GroupLinkedNoticeProps {
  linkedGroupId: string | null;
  linkedGroupName: string | null;
  linkedGroupType: 'manual' | 'template' | null;
  currentType: 'manual' | 'template';
}

export const GroupLinkedNotice = ({
  linkedGroupId,
  linkedGroupName,
  linkedGroupType,
  currentType,
}: GroupLinkedNoticeProps) => {
  const { t } = useTranslation('groups');

  if (!linkedGroupId || !linkedGroupName || !linkedGroupType) return null;

  return (
    <div className="rounded-lg border border-border-subtle bg-surface-sunken/50 px-3 py-2.5 text-body-sm text-fg-secondary">
      <p className="flex flex-wrap items-center gap-1">
        <span>
          {t(currentType === 'manual' ? 'linked.pairedWithAutoFill' : 'linked.pairedWithManual')}
        </span>
        <Link
          to={`/groups/${linkedGroupId}`}
          className="font-medium text-brand hover:underline"
        >
          {linkedGroupName}
        </Link>
      </p>
      <p className="mt-1 text-caption text-fg-muted">{t(`linked.syncHint.${currentType}`)}</p>
    </div>
  );
};

export const linkedAutoFillDefaultName = (name: string, format: (key: string, params: { name: string }) => string) =>
  format('linked.autoFillName', { name: name.trim() });
